// const VALUES = {
//   31: 'open',
//   33: 'rough',
//   32: 'smooth',
// }
const VALUES = {
  31: 'open',
  33: 'smooth',
  32: 'disturbed',
  34: 'rough'
}

export const getDates = (data, formatter = item => item) => {
  const dates = data[0].map(item => formatter(new Date(item.timestamp)))

  return dates
}

const iceDataTransform = dataRaw => {
  // add x and y keys for victory js
  const data = dataRaw.asMutable().sort((a, b) => a.date < b.date ? -1 : 1)
  const dataXy = data.map(item => ({ ...item, y: item.ratio * 100, x: item.timestamp }))
  const timestamps = [...new Set(dataXy.map(item => item.timestamp))]
  const dataTypeArray = Object.keys(VALUES).reduce((array, item) => {
    const dataType = dataXy.filter(datum => datum.type === Number(item))
    array.push(dataType)
    return array
  }, [])

  return dataTypeArray
}

export default iceDataTransform



// WEBPACK FOOTER //
// ./src/utility/iceDataTransform.js